export const OpportunitiesIcon = ({
  color = "#0F2C52",
}: {
  color?: string;
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.57474 11.2667C5.71232 11.4752 5.9009 11.6451 6.12257 11.7603C6.34425 11.8756 6.59168 11.9322 6.84141 11.925C7.18249 11.9552 7.52171 11.8496 7.78541 11.6312C8.0491 11.4127 8.21595 11.0991 8.24974 10.7583C8.21801 10.4161 8.05203 10.1003 7.78811 9.88014C7.52419 9.65994 7.1838 9.55323 6.84141 9.58334C6.50038 9.61114 6.16214 9.50336 5.90006 9.2834C5.63797 9.06344 5.47318 8.74902 5.44141 8.40834C5.47522 8.06916 5.6409 7.75683 5.90275 7.53862C6.16461 7.32041 6.50169 7.21377 6.84141 7.24167C7.09152 7.232 7.33985 7.28762 7.56194 7.40305C7.78404 7.51848 7.97226 7.68975 8.10807 7.9"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.8418 11.9248V12.7081"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.8418 6.45801V7.24134"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 12.708V10.208"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.583 12.708V7.70801"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.25 0.625H18.75C18.75 0.625 19.375 0.625 19.375 1.25V3.33333C19.375 3.33333 19.375 3.95833 18.75 3.95833H1.25C1.25 3.95833 0.625 3.95833 0.625 3.33333V1.25C0.625 1.25 0.625 0.625 1.25 0.625Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 3.95801H18.125V14.9997H1.875V3.95801Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 18.5417V15"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.625 15H19.375"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 19.3753C11.25 18.917 10.6917 18.542 10 18.542C9.30833 18.542 8.75 18.917 8.75 19.3753"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
